// extracted by mini-css-extract-plugin
export default {"form":"formProvider_form__wRcEh"};